import { SECONDS_PER_HOUR } from "@/config/constants";

/**
 * Formats duration in seconds to a human-readable string.
 * CRITICAL: This function expects duration in SECONDS (not minutes).
 * @param durationInSeconds - Duration in seconds
 * @returns Formatted string like "2 Std. 30 Min." or "-" for invalid values
 */
export const formatDuration = (durationInSeconds: number): string => {
  if (durationInSeconds === null || durationInSeconds === undefined || isNaN(durationInSeconds)) {
    console.warn('Invalid duration value:', durationInSeconds);
    return '-';
  }

  const hours = Math.floor(durationInSeconds / SECONDS_PER_HOUR);
  const minutes = Math.floor((durationInSeconds % SECONDS_PER_HOUR) / 60);
  
  // Always include both hours and minutes for consistent layout
  return `${hours} Std. ${minutes} Min.`;
};
